<template>
  <div id="app-curriculum-base-body">
    <!-- 保留 -->
    <div></div>
    <!-- 搜索结果 -->
    <div v-if="listInfo.length !== 0" id="app-curriculum-base-result-list">
      <ul>
        <li v-for="item in bufferInfo" :key="item.id" style="float: left;cursor:pointer;">
          <ClassCard :class-info="item" open-type="push"></ClassCard>
        </li>
      </ul>
      <div style="clear:both;"></div>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     style="position: absolute;left: 0;right: 0;bottom: 0" background layout="prev, pager, next"
                     :page-size="16" :pager-count="5" :total="listInfo.length">
      </el-pagination>
    </div>
    <div id="app-curriculum-base-result-empty" v-else>没有搜索到内容（；´д｀）ゞ</div>
  </div>
</template>

<script>
import ClassCard from "@/views/share/ClassCard";

export default {
  name: "CurriculumBaseList",
  components: {ClassCard},
  props: {
    listInfo: Array
  },
  data() {
    return {
      bufferInfo: undefined,
    }
  },
  beforeMount() {
    this.processTableData();
  },
  watch: {
    listInfo: function () {
      this.processTableData();
    }
  },
  methods: {
    processTableData() {
      if (this.listInfo.length > 16) {
        this.bufferInfo = this.listInfo.slice(0, 16)
      } else {
        this.bufferInfo = this.listInfo
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (val === 1) {
        this.bufferInfo = this.listInfo.slice(0, 16)
      } else {
        this.bufferInfo = this.listInfo.slice((val - 1) * 16, (((val - 1) * 16) + 16))
      }
      //返回顶部
      document.getElementById("app-curriculum-base-body").scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    },
  }
}
</script>

<style scoped>


#app-curriculum-base-body {
  width: 1160px;
  margin: auto
}

#app-curriculum-base-result-list {
  position: relative;
  padding-bottom: 50px;
  padding-top: 20px;
  padding-left: 20px;
  margin: auto;
}

#app-curriculum-base-result-empty {
  padding-top: 40px;
  padding-bottom: 20px;
  font-size: 25px;
}

</style>